@if (hauptartikel(); as hauptartikel) {
<div class="c column no-wrap" style="position: relative">
  <div class="item-grid">
    <div class="image-container" (click)="imageTapped.emit()">
      <ng-container>
        <img [attr.src]="hauptartikel | loadArchiveFile | async" class="image pointer" alt="item image">
      </ng-container>
    </div>

    <!-- <span class="image" (click)="beweausTapped.emit()">&nbsp;</span> -->

    <div class="c column center-v truncate pointer" (click)="beweausTapped.emit()">
      <span class="soft-overline truncate">{{ hauptartikel?.cartikelnummer }}</span>
      <strong class="truncate" style="word-break: break-all; word-wrap: normal">{{ (hauptartikel?.artbez1?.length || 0) < 1 ? "Keine Artbez vorhanden" : hauptartikel?.artbez1 }}</strong>
      @if (hauptartikel?.artbez2) {
        <span class="soft-text color-light truncate"> {{ hauptartikel?.artbez2 }}</span>
      }
      @if (hauptartikel?.artbez3) {
        <span class="soft-text color-light truncate"> {{ hauptartikel?.artbez3 }}</span>
      }
      <!-- <strong class="soft-text quantity-label">{{ beweau?.menge }} {{ beweau?.arteh }}</strong> -->
    </div>

    <div class="c column end align-end">
      <span class="soft-text price-label pointer" (click)="priceTapped.emit()">{{ price() | currency:'EUR' }}</span>
    </div>

  </div>
  @if (hauptartikel?.manartikelbez && (hauptartikel?.manartikelbez?.length || 0) > 0) {
    <div class="c row border-top soft-text-s">
      {{ hauptartikel?.manartikelbez }}
    </div>
  }
  <!-- absolute positioned in the top right corner -->
  <a (click)="openLink(url())"
     class="link-button"
     [class.pointer]="url() && (url()?.length || 0)> 1">
    <i class="fas fa-globe-africa pointer" style="color: var(--colorTertiary); font-size: 1.625rem"></i>
  </a>
</div>
} @else {
  <div class="flex flex-col w-full soft-card rounded-sm gap-3 mt-3">
    <div class="h-3 w-10 skeleton"></div>
  </div>
}